// Anke, 2026-07-16 — Raster mit Einrasten. Diese Datei ist die reine Rechnung:
// kein Konva, kein Zustand, damit sie ohne Browser pruefbar ist.
//
// Einrasten ist Runden: Ein Weltwert wird auf das naechste Vielfache des
// Rasterabstands gebracht. Der Abstand ist FEST in Welteinheiten (Ankes
// Entscheidung "wie Millimeterpapier") — dieselben Objekte liegen dadurch
// unabhaengig vom Zoom immer an denselben Linien.

/**
 * Rasterabstand in Welteinheiten. Fest, nicht zoomabhaengig. Zum Vergleich:
 * eine Haftnotiz ist standardmaessig 180 breit, also 9 Kaestchen.
 */
export const GRID_STEP_WORLD = 20;

/** Rundet einen einzelnen Wert auf das naechste Rastervielfache. */
export function snapValueToGrid(value: number, step: number = GRID_STEP_WORLD): number {
  return Math.round(value / step) * step;
}

/** Rundet einen Punkt (beide Achsen) aufs Raster. */
export function snapPointToGrid(
  point: { x: number; y: number },
  step: number = GRID_STEP_WORLD,
): { x: number; y: number } {
  return { x: snapValueToGrid(point.x, step), y: snapValueToGrid(point.y, step) };
}

/**
 * Rundet eine Laenge (Breite/Hoehe) aufs Raster, aber mindestens auf EIN
 * Kaestchen. Ohne die Untergrenze koennte ein sehr klein gezogenes Objekt beim
 * Einrasten auf Groesse 0 zusammenfallen.
 */
export function snapSizeToGrid(size: number, step: number = GRID_STEP_WORLD): number {
  return Math.max(step, Math.round(size / step) * step);
}
